// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue2-daterange-picker/dist/vue2-daterange-picker.css
// module id = 1180
// module chunks = 2